import { render } from "./TheBikesDetails.vue?vue&type=template&id=784fd984"
import script from "./TheBikesDetails.vue?vue&type=script&lang=js"
export * from "./TheBikesDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__